/** @format */

import React, { useMemo, useState } from "react";
import DOMPurify from "dompurify";
import { Form } from "react-bootstrap";

function EditActivityModalOrgNameSwapper({
  editModalRowData,
  setEditModalRowData,
  inventory,
  orgNameSelect,
}) {
  const [toggleSelectOrg, setToggleSelectOrg] = useState(false);
  const organizationToggler = () => {
    setToggleSelectOrg((prevState) => !prevState);
  };

  const renderBasedOnInventory = useMemo(() => {
    if (
      inventory.inventoryData &&
      inventory.inventoryData.length > 0 &&
      toggleSelectOrg
    ) {
      return (
        <Form.Group className="mb-3">
          <Form.Label>
            Organization<span className="text-danger">*</span>
          </Form.Label>
          <Form.Select
            ref={orgNameSelect}
            className="form-control"
            required
            name="type"
            value={editModalRowData.type || ""}
            onChange={(e) => {
              setEditModalRowData((state) => ({
                ...state,
                type: e.target.value,
              }));
            }}
          >
            <option value="" disabled>Select Organization</option>
            {inventory.inventoryData.map((option) => (
              <option key={option.site_id} value={option.site_name.trim()}>
                {option.site_name}
              </option>
            ))}
          </Form.Select>
          <p className="invalid-feedback">Interaction type is required</p>
          <button
            className="btn btn-link p-0 mt-1"
            onClick={() => organizationToggler()}
          >
            Enter Organization Name
          </button>
        </Form.Group>
      );
    } else {
      return (
        <Form.Group className="mb-3">
          <Form.Label>
            Organization<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            name="type"
            type="text"
            value={editModalRowData.type}
            onChange={(e) => {
              const sanitizedType = DOMPurify.sanitize(e.target.value);
              setEditModalRowData((state) => ({
                ...state,
                type: sanitizedType,
              }));
            }}
            required
          />
          <button
            className="btn btn-link p-0 mt-1"
            type="button"
            onClick={() => organizationToggler(true)}
          >
            Search My Organizations
          </button>
        </Form.Group>
      );
    }
  }, [
    inventory,
    editModalRowData.type,
    setEditModalRowData,
    orgNameSelect,
    toggleSelectOrg,
  ]);

  return renderBasedOnInventory;
}

export default EditActivityModalOrgNameSwapper;